import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '@/lib/i18n';
import { Cookie, X } from '@phosphor-icons/react';

const STORAGE_KEY = 'dmr-cookie-consent-v1';

export default function CookieBanner() {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const stored = typeof window !== 'undefined' ? localStorage.getItem(STORAGE_KEY) : 'accepted';
    if (!stored) {
      const timer = setTimeout(() => setOpen(true), 800);
      return () => clearTimeout(timer);
    }
  }, []);

  const decide = (choice) => {
    try { localStorage.setItem(STORAGE_KEY, choice); } catch (_) {}
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed inset-x-4 bottom-4 md:inset-x-auto md:right-6 md:bottom-6 md:max-w-md z-[100] animate-[fadeUp_0.5s_ease]"
    >
      <div className="relative bg-[#0A1128] text-white border border-[#C5A059]/40 shadow-2xl p-6 md:p-7">
        <button
          onClick={() => decide('necessary')}
          data-testid="cookie-close"
          className="absolute top-3 right-3 text-white/40 hover:text-[#C5A059] transition-colors"
          aria-label="close"
        >
          <X size={16} />
        </button>
        <div className="flex items-start gap-4">
          <Cookie size={28} weight="thin" className="text-[#C5A059] shrink-0 mt-1" />
          <div className="flex-1">
            <div className="eyebrow text-[#C5A059]">{t.cookie.eyebrow}</div>
            <h3 className="font-display text-xl text-white mt-2">{t.cookie.title}</h3>
            <p className="text-white/70 text-[13px] leading-relaxed mt-3">
              {t.cookie.body}{' '}
              <Link to="/datenschutz" className="text-[#C5A059] hover:underline">{t.cookie.privacyLink}</Link>.
            </p>
            <div className="mt-5 flex flex-col sm:flex-row gap-2">
              <button
                onClick={() => decide('accepted')}
                data-testid="cookie-accept"
                className="bg-[#C5A059] hover:bg-[#B38F4D] text-[#0A1128] px-5 py-3 text-[11px] font-semibold tracking-[0.2em] uppercase transition-colors flex-1"
              >
                {t.cookie.accept}
              </button>
              <button
                onClick={() => decide('necessary')}
                data-testid="cookie-necessary"
                className="bg-transparent border border-white/25 hover:border-[#C5A059] hover:text-[#C5A059] text-white px-5 py-3 text-[11px] font-semibold tracking-[0.2em] uppercase transition-all flex-1"
              >
                {t.cookie.necessary}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
